import { Injectable, OnDestroy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { QuestionAttemptEntityQuery } from '@examdojo/question';
import { distinctUntilChanged, tap } from 'rxjs';
import { SubmissionSpinnerDialogService } from './submission-spinner-dialog.service';

@Injectable()
export class SubmissionSpinnerDialogEffect implements OnDestroy {
  constructor(
    private readonly questionAttemptQuery: QuestionAttemptEntityQuery,
    private readonly submissionSpinnerDialogService: SubmissionSpinnerDialogService,
  ) {
    this.syncDialogWithUploadingState().pipe(takeUntilDestroyed()).subscribe();
  }

  ngOnDestroy(): void {
    this.submissionSpinnerDialogService.dismiss();
  }

  private syncDialogWithUploadingState() {
    return this.questionAttemptQuery.isUploadingSolution$.pipe(
      distinctUntilChanged(),
      tap((isUploading) => {
        if (isUploading) {
          this.submissionSpinnerDialogService.openDialog();
        } else {
          this.submissionSpinnerDialogService.dismiss();
        }
      }),
    );
  }
}
